'use client';

import { useEffect, useState } from 'react';

import classNames from 'classnames';
import { NextIntlClientProvider } from 'next-intl';
import styled from 'styled-components';

import { Skeleton } from 'src/app/components/Elements/Skeleton';
import { useIsSpanishRoute } from 'src/app/hooks/useIsSpanishRoute';
import { LayoutRoutes } from 'src/app/popsicle/router/layoutRoutes';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
`;

const displayName = 'I18nNative';

export const I18nNative = () => {
  const [messages, setMessages] = useState<Record<string, any>>({});
  const [locale, setLocale] = useState<string>('en');
  const [isLoading, setIsLoading] = useState(true);
  const isSpanishRoute = useIsSpanishRoute();

  useEffect(() => {
    // Load translations based on route
    const loadTranslations = async () => {
      setIsLoading(true);
      try {
        let translationMessages;
        if (isSpanishRoute) {
          translationMessages = await import('../../translations/es.json');
          setMessages(translationMessages);
          setLocale('es');
        } else {
          translationMessages = await import('../../translations/en.json');
          setMessages(translationMessages);
          setLocale('en');
        }
      } catch (error) {
        console.error('Failed to load translations:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadTranslations();
  }, [isSpanishRoute]);

  // Only render when messages are loaded
  if (isLoading) {
    // Return a loading state or placeholder while translations load
    return <Skeleton />;
  }

  return (
    <StyledContainer className={classNames('marketing', 'layout-native')}>
      <NextIntlClientProvider locale={locale} messages={messages}>
        <LayoutRoutes renderKey="content" displayName={displayName} location={location} />
      </NextIntlClientProvider>
    </StyledContainer>
  );
};

I18nNative.displayName = displayName;
